import {
  __esm
} from "./chunk-UYUHCTR5.mjs";

// src/getAllCacheRecords.ts
var getAllCacheRecords, getAllCacheRecords_default;
var init_getAllCacheRecords = __esm({
  "src/getAllCacheRecords.ts"() {
    getAllCacheRecords = (rootCache) => {
      const stack = [rootCache];
      const allCacheRecords = [];
      while (stack.length) {
        const cacheData = stack.pop();
        if (!cacheData)
          throw new Error("Something went really wrong");
        if (cacheData.isCached) {
          allCacheRecords.push(cacheData);
        }
        cacheData.subCaches.forEach((subCacheData) => stack.push(subCacheData));
      }
      return allCacheRecords;
    };
    getAllCacheRecords_default = getAllCacheRecords;
  }
});

export {
  getAllCacheRecords,
  getAllCacheRecords_default,
  init_getAllCacheRecords
};
